import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wzn9lw2y2: FaireProductEntity = {
  token: "p_5wzn9lw2y2",
  type: "product",
  name: "Rose Quartz Kitty Face, Crystal Cat",
  brandToken: "b_en1yij2pf6",
  brandName: "Natures Artifacts Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/e72222d91b8ec2259673de4ceb045b589c3378644a7febc7dc8b32c67b397bee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2d057b0eac709e0a7e057caf8a8c266c92d9bac31cd763ad830c16732f521692.jpeg",
    "https://cdn.faire.com/fastly/c3766b804722bd145d429a387b529362f458655692970dc5a8604d5ee301213d.jpeg",
    "https://cdn.faire.com/fastly/fa7c2a0be7ef1ceaed36453ad790109abdba16d01593d4f054fe29ba4c2691a0.jpeg",
    "https://cdn.faire.com/fastly/62d5d3c455d47e63f27b476b0a1fe00cc9e5fc04042d4ba35a41cf7dc6057360.jpeg",
    "https://cdn.faire.com/fastly/cd3ec97f4b020da2dbb6b3837a6a00c96ccfffa7f2d2ec82c9ec2b9176163a2f.jpeg",
    "https://cdn.faire.com/fastly/43c7281685f62ae317afc1a238b9b254731c4be10f5d02dd7f3e7007b315ead0.jpeg",
    "https://cdn.faire.com/fastly/3fc22258842997f634c901a4b8ef1881cda14e69f51232acbec67cd6983075de.jpeg",
    "https://cdn.faire.com/fastly/11468e5f7c9be77c3f3316bc1b82783feb46e312a7f07be0ddabc896759d501e.jpeg",
    "https://cdn.faire.com/fastly/ed58f359668c8467e3dbb4cb8a90b62d133998bdd57d510dd4d047ff541dff4a.jpeg",
  ],
  priceDollars: 5.2,
  description:
    'These beautiful crystal animal faces form an ideal visual meditation practice. Genuine gemstone kitty face, hand-carved in Brazil.  Approx. 1" in size.\nDue to the nature of the stone and hand carving, the sizes may vary.',
  tags: [],
  msrpDollars: 10.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:21.370Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
